import Text from "@src/lib/ui/Text";
import Widget from "@src/features/home/Widget";
import { Skeleton } from "@src/lib/ui/Skeleton";
import { gql } from "@apollo/client";
import IncompleteAssignmentsSheet from "@src/features/home/IncompleteAssignmentsSheet";
import { useIncompleteAssignmentsWidgetQuery } from "./IncompleteAssignmentsWidget.generated";
import CircleHalfFillIcon from "@src/lib/icons/18px/circle-half-fill";

const IncompleteAssignmentsWidget: React.FC = () => {
  const { data, loading } = useIncompleteAssignmentsWidgetQuery();
  const incomplete = data?.MyTeamIncompleteAssignments.totalCount || 0;
  const pastDue = data?.AdminEmployeesWithPastDueAssignments.totalCount || 0;
  return (
    <Widget
      title="Incomplete Assignments"
      Icon={CircleHalfFillIcon}
      className="flex-1 self-stretch shadow-none"
    >
      {loading ? (
        <Skeleton className="h-[34px] w-10 rounded-md" />
      ) : (
        <IncompleteAssignmentsSheet>
          <div className="group mr-auto flex cursor-pointer flex-row items-center gap-1 align-middle">
            <Text variant="display-bold" className="group-hover:underline">
              {incomplete}
            </Text>
            {pastDue > 0 && (
              <>
                <div className="rounded-lg bg-orange-1 px-2">
                  <Text variant="compact-title" className="text-orange-10">
                    ⚠ {pastDue}
                  </Text>
                </div>
                <Text variant="fine-print-description" className="text-gray-8">
                  people past due
                </Text>
              </>
            )}
          </div>
        </IncompleteAssignmentsSheet>
      )}
    </Widget>
  );
};

gql`
  query IncompleteAssignmentsWidget {
    MyTeamIncompleteAssignments {
      totalCount
    }
    AdminEmployeesWithPastDueAssignments(input: {}) {
      totalCount
    }
  }
`;

export default IncompleteAssignmentsWidget;
